export default __webpack_public_path__ + "static/media/about-img-2.fc026bf8.png";